export default class Assets {
  static banner1MilkTea = new URL("./poster-tra-sua-dac-sac.jpg", import.meta.url).href;
  static AppLogo = new URL("./toputii.png", import.meta.url).href;
  static TING_TING = new URL("./tingting.mp3", import.meta.url).href;
  static NEW_ORDER_TEXT = new URL("./newOrderText.mp3", import.meta.url).href;
  static MENU_PAGE = new URL("./menu_page.jpg", import.meta.url).href;
  static QR_MONEY = new URL("./TRAN_VAN_TAM_QR.png", import.meta.url).href;
}
